const KNOWN_UNIT_TYPE_LABELS = {
  clp: "CLP",
  billboard: "Billboard",
  giantboard: "Giantboard",
  giandtboard: "Giantboard",
  megalight: "Megalight",
  megaboard: "Megaboard",
  duvar: "Duvar",
  metroboard: "Metroboard",
};

const titleCase = (value) =>
  value
    .toLocaleLowerCase("tr-TR")
    .split(/\s+/)
    .map((word) => word ? word.charAt(0).toLocaleUpperCase("tr-TR") + word.slice(1) : word)
    .join(" ");

export const normalizeUnitType = (unitType) => {
  const text = String(unitType || "").trim();
  if (!text) return "";
  const key = text.toLocaleLowerCase("tr-TR");
  return KNOWN_UNIT_TYPE_LABELS[key] || titleCase(text);
};
